<template>
   <!-- Register Discount Modal -->
   <div class="modal fade" id="registerDiscountModal" tabindex="-1" aria-labelledby="registerDiscountLabel" aria-hidden="true">
   <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content border-0 shadow-lg rounded-3">
         <div class="modal-body text-center py-5 position-relative">

         <!-- Close button -->
         <button type="button" class="btn-close position-absolute top-0 end-0 m-3" data-bs-dismiss="modal" aria-label="Close"></button>

         <!-- Title -->
         <h4 class="fw-bold text-dark mb-2">Register And Get 5% Discount!</h4>
         <div class="mx-auto mb-3" style="width: 40px; height: 2px; background-color: #e83e8c;"></div>

         <!-- Subtitle -->
         <p class="text-muted mb-4">
            Register to <strong>CakeGurus</strong> and get 5% flat discount on all cakes except <em>'Regular Cakes'</em>.
         </p>

         <!-- Button -->
         <a href="/register" class="btn btn-dark btn-lg px-5 rounded-pill shadow-sm">
            REGISTER
         </a>

         </div>
      </div>
   </div>
   </div>
</template>
<script setup>
import { useAuth } from '@/composables/useAuth'
import { onMounted } from 'vue'

const { isAuthenticated } = useAuth()

onMounted(() => {  
  if (!isAuthenticated()) {
    const modalEl = document.getElementById('registerDiscountModal')
    if (modalEl && window.bootstrap) {
      const registerModal = new window.bootstrap.Modal(modalEl, {
        backdrop: 'static',
        keyboard: false
      })
      registerModal.show()
    }
  }
})
</script>
<style scopped>
.modal-content {
  border-radius: 1rem;
  padding: 1rem;
}
.btn-dark {
  background-color: #212121;
  border: none;
  transition: all 0.3s ease;
}
.btn-dark:hover {
  background-color: #000;
  transform: scale(1.03);
}
</style>